class CollectionColumnsToggle {
  constructor() {
    this.columns = localStorage.getItem('collection-columns') || '4';
    this.init();
  }

  init() {
    this.bindEvents();
    this.setActiveColumns(this.columns);
  }

  bindEvents() {
    const toggleButtons = document.querySelectorAll('.column-toggle-btn');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const columns = e.currentTarget.dataset.columns;
        this.switchColumns(columns);
      });
    });

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  switchColumns(columns) {
    if (this.columns === columns) return;
    
    this.setActiveColumns(columns);
    this.updateProductGrid(columns);
    this.saveColumnsPreference(columns);
  }

  setActiveColumns(columns) {
    const buttons = document.querySelectorAll('.column-toggle-btn');
    const productGrid = document.querySelector('.product-grid');
    
    buttons.forEach(button => {
      button.classList.toggle('active', button.dataset.columns === columns);
    });
    
    if (productGrid) {
      productGrid.classList.remove('columns-1', 'columns-2', 'columns-3', 'columns-4');
      productGrid.classList.add(`columns-${columns}`);
    }
    
    this.columns = columns;
  }

  updateProductGrid(columns) {
    const gridItems = document.querySelectorAll('.grid__item');
    
    gridItems.forEach(item => {
      item.style.width = '';
      item.style.flex = '';
    });
  }

  handleResize() {
    if (window.innerWidth <= 480) {
      const productGrid = document.querySelector('.product-grid');
      if (productGrid && !productGrid.classList.contains('columns-1')) {
        productGrid.classList.add('mobile-single-column');
      }
    } else {
      const productGrid = document.querySelector('.product-grid');
      if (productGrid) {
        productGrid.classList.remove('mobile-single-column');
      }
    }
  }

  saveColumnsPreference(columns) {
    localStorage.setItem('collection-columns', columns);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionColumnsToggle();
});

document.addEventListener('turbo:load', () => {
  new CollectionColumnsToggle();
});